<div>
    <div class="icon-wrapper">
        <mat-icon
            [routerLink]="['/character/', { outlets: { 'character-page': ['overview'] } }]"
            routerLinkActive="active-link"
            >home</mat-icon
        >
        <span>
            <mat-icon
                [routerLink]="['/character/', { outlets: { 'character-page': ['background'] } }]"
                routerLinkActive="active-link"
                >local_library</mat-icon
            >
            <mat-icon
                [routerLink]="['/character', { outlets: { 'character-page': ['gear'] } }]"
                routerLinkActive="active-link"
                >checkroom</mat-icon
            >
            <mat-icon
                [routerLink]="['/character', { outlets: { 'character-page': ['possessions'] } }]"
                routerLinkActive="active-link"
                >work</mat-icon
            >
            <mat-icon
                [routerLink]="['/character', { outlets: { 'character-page': ['skills'] } }]"
                routerLinkActive="active-link"
                fontSet="material-symbols-outlined"
                >military_tech</mat-icon
            >
            <mat-icon
                [routerLink]="['/character', { outlets: { 'character-page': ['spells'] } }]"
                routerLinkActive="active-link"
                >auto_stories</mat-icon
            >
            <mat-icon
                [routerLink]="['/character', { outlets: { 'character-page': ['weapons'] } }]"
                routerLinkActive="active-link"
                fontSet="material-symbols-outlined"
                >swords</mat-icon
            >
            <mat-icon
                [routerLink]="['/character', { outlets: { 'character-page': ['camp'] } }]"
                routerLinkActive="active-link"
                fontSet="material-symbols-outlined"
                >camping</mat-icon
            >
            <span class="settings">
                <mat-icon [routerLink]="['/settings']" routerLinkActive="active-link">settings</mat-icon>
            </span>
            <!-- <mat-icon
                [routerLink]="['/character', { outlets: { 'character-page': ['spells'] } }]"
                routerLinkActive="active-link"
                >auto_fix_high</mat-icon
            > -->
        </span>
    </div>
    <div class="label-wrapper">
        <app-experience />
        <app-money></app-money>
    </div>
</div>
